<!--
  App.vue — 应用根组件
  职责：挂载 <router-view /> 作为页面出口，定义全局基础样式重置。
  主题：参考 chanjing.cc 的浅灰+白+橙色点缀配色方案。
-->
<template>
  <a-config-provider :theme="themeConfig">
    <router-view />
  </a-config-provider>
</template>

<script setup>
import { reactive } from "vue";

/** Ant Design Vue 4 主题令牌：将主色调切换为橙红色 (#FF6A39) */
const themeConfig = reactive({
  token: {
    colorPrimary: "#FF6A39",
    colorLink: "#FF6A39",
    colorLinkHover: "#FF8E53",
    borderRadius: 8,
  },
});
</script>

<style>
/* ===== 全局样式重置 ===== */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  background: #f5f6f8;
  color: #333333;
}

/* ===== 全局 Ant Design 覆盖 ===== */

/* 主按钮渐变 */
.ant-btn-primary {
  background: linear-gradient(90deg, #ff8e53 0%, #ff6a39 100%) !important;
  border-color: #ff6a39 !important;
  box-shadow: 0 2px 8px rgba(255, 106, 57, 0.3);
  transition: all 0.3s ease;
}
.ant-btn-primary:hover {
  background: linear-gradient(90deg, #ff9f6c 0%, #ff7e52 100%) !important;
  border-color: #ff7e52 !important;
  box-shadow: 0 4px 12px rgba(255, 106, 57, 0.4);
}

/* 卡片统一圆角与阴影 */
.ant-card {
  border-radius: 8px !important;
  border: 1px solid #eceef2 !important;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.03);
}

/* 表格头部背景 */
.ant-table-thead > tr > th {
  background: #f8f9fb !important;
}

/* 分页器选中色 */
.ant-pagination-item-active {
  border-color: #ff6a39 !important;
}
.ant-pagination-item-active a {
  color: #ff6a39 !important;
}
</style>
